export default __webpack_public_path__ + "static/media/23.8b33d668.jpg";